export const ImageShowcaseSection = () => {
  return (
    <section className="py-8 sm:py-16 bg-background" data-testid="image-showcase-section">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <img
            src="https://customer-assets.emergentagent.com/job_462b1c9b-939c-4705-8ff2-b6f811719f70/artifacts/r3kijdr1_Stock_Datacenter7.png"
            alt="Panorama – Energieversorgung & Speichersysteme"
            className="w-full rounded-lg shadow-lg object-cover aspect-video md:aspect-[21/9]"
            loading="lazy"
            data-testid="image-showcase-panorama"
          />
        </div>
      </div>
    </section>
  );
};
